<template>
    <div class="root" v-loading="loading">
    <div class="app">
        <router-link to="/" replace>
        <div class="header">
            <div class="iconfont back-icon">&#xe624;</div>
        </div>
        </router-link>

        <div class="phbdiv">
            <div class="item" style="font-weight:bold;">
                <div class="item1">排名</div>
                <div class="item2">姓名</div>
                <div class="item3">单位</div>
                <div class="item5">得分</div>
                <div class="item4">用时</div>
            </div>

            <div v-for="(item,index) in list" :key="item.userid">
            <div class="item">
                <div class="item1">
                    <div v-if="index<=2">
                    </div>
                    <div v-else>
                        {{index+1}}
                    </div>
                </div>
                <div class="item2">{{item.name}}</div>
                <div class="item3">{{item.company}}</div>
                <div class="item5">{{item.fenshu}}</div>
                <div class="item4">{{item.time}}</div>
            </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'paihangbang',
  data:function(){
    return{
        list:[],
        loading:false
    }
  },
  components: {
  },
  methods: {
    getHomeInfo () {
        this.loading = true;
      axios.post('/api/Question/ranking', 
            {
            limit: 50,
            uid:1,
            token:'8cfb3eef6e86e263322fcc57a8d760e0'
            }
        )
        .then(this.getHomeInfoSucc)
    },
    getHomeInfoSucc (res) {
        this.loading=false;
      res = res.data
        console.log(res);
      if (res && res.Code==200) {
        this.list = res.list
        console.log(this.list);
      }
    }
  },
  mounted () {
    this.getHomeInfo()
  }
}
</script>
<style scoped>

.root{
    background-color: #FFB556;
}
.app{
    background-repeat: no-repeat;
    background-size: 100%;
    width:100%;
    height:100vh;
    overflow-y: scroll;
}
.header{
    padding: .24rem;
}
.back-icon{
    font-size: .4rem;
    color:#fff;
}
.item{
    display: flex;
    margin: 12px 10px;
    align-items: center;
}
.phbdiv{
    width: 86vw;

    background: #fff;
    padding: 1px;
    margin: auto;
    margin-top: 50.8vw;
    height: calc(100vh - 50.8vw - 10vh);
    overflow-y: scroll;
}
.item1{
    width: 8vw;
    text-align: center;
    margin-right: 10px;
}
.item2{
    width: 20vw;
}
.item3{
    flex:1;
    height: 14px;
    overflow: hidden;
}
.item4{
    width: 10vw;
}
.item5{
    width: 14vw;
    color: #FE8840;
}
.phbicon{
    width: 22px;
}
</style>



// WEBPACK FOOTER //
// src/pages/paihangbang/paihangbang.vue